import { render, staticRenderFns } from "./AffiliateLinks.vue?vue&type=template&id=145cabc4&scoped=true"
import script from "./AffiliateLinks.vue?vue&type=script&lang=js"
export * from "./AffiliateLinks.vue?vue&type=script&lang=js"
import style0 from "./AffiliateLinks.vue?vue&type=style&index=0&id=145cabc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cabc4",
  null
  
)

export default component.exports